import httpClient from "../../api/httpClient";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";

export const getUsersByTenant = createWrappedAsyncThunk(
  "users/getUsersByTenant",
  async ({ tenant_id }) => {
    const { data } = await httpClient.get(`users`, {
      params: {
        tenant_id,
      },
    });
    return { tenant_id, data };
  }
);

export const inviteUserInTenant = createWrappedAsyncThunk(
  "users/inviteUserInTenant",
  async (payload) => {
    return await httpClient.post(`invite-user`, payload);
  }
);
